import { Route, Link, NavLink } from "react-router-dom";
import Homepage from "./views/HomePage";
import Contacts from "./views/Contact";
import Resume from "./views/Resume";

import "./App.css";

const NavBar = () => (
  <header>
    <nav>
      <Link to="/">Home</Link>
      <NavLink to="/resume">Resume</NavLink>
      <NavLink to="/contacts">Contacts</NavLink>
    </nav>
  </header>
);

const Footer = () => (
  <div className="copyright">
    Copyright &copy; <i>habinezajanvier</i>
    {new Date().getFullYear()} All rights reserved
  </div>
);

function App() {
  return (
    <div className="App">
      <NavBar />
      <Route path="/" exact component={Homepage} />
      <Route path="/contacts" exact component={Contacts} />
      <Route path="/resume" exact component={Resume} />
      <Footer />
    </div>
  );
}

export default App;
